import React from "react";
import { useFormContext } from "react-hook-form";
import I18n from "i18n-js";

import Option from "./Option";

import blank from "../../../../assets/icons/pdp/blank.svg";
import template from "../../../../assets/icons/pdp/template.svg";
import generate from "../../../../assets/icons/pdp/generate.svg";

const Options = ({ loading }) => {

  const { watch, setValue, handleSubmit, formState: { errors }} = useFormContext();

  const option = watch("option");
  const error = errors.option;

  const handleOptionSelected = (option) => {
    setValue("option", option);
  }

  return (
    <div className="options">
      <div className="items">
        <Option
          icon={blank}
          title={I18n.t("pdp.modals.create_plan.options.blank.title")}
          description={I18n.t("pdp.modals.create_plan.options.blank.description")}
          disabled={loading}
          error={error?.message}
          onClick={() => handleOptionSelected("blank")}
        />
        <Option
          icon={template}
          title={I18n.t("pdp.modals.create_plan.options.template.title")}
          description={I18n.t("pdp.modals.create_plan.options.template.description")}
          disabled={loading}
          error={error?.message}
          onClick={() => handleOptionSelected("template")}
        />
        <Option
          icon={generate}
          title={I18n.t("pdp.modals.create_plan.options.generate.title")}
          description={I18n.t("pdp.modals.create_plan.options.generate.description")}
          loading={loading}
          titleLoading={I18n.t("pdp.modals.create_plan.options.generate.generating")}
          error={error?.message}
          onClick={() => handleOptionSelected("generate")}
        />
      </div>
      <div className="error">
        {error?.message}
      </div>
    </div>
  );
}

export default Options;
